import { useAuthScopes } from '@/lib/useAuthScopes';

const buildQueryParams = (): string => {
    const { activeScope } = useAuthScopes();

    const token = localStorage.getItem('api_token');

    const queryParams: Record<string, string> = {};
    if (token) {
        queryParams.token = token;
    }

    if (activeScope.value) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { role, ...withoutRole } = activeScope.value;
        queryParams.activeScope = JSON.stringify(withoutRole);
    }

    return new URLSearchParams(queryParams).toString();
};

const buildLink = (baseUrl: string | undefined, path: string): string => {
    const normalizedPath = path.replace(/^\/?/, '');
    let url = `${baseUrl}${normalizedPath}`;

    if (baseUrl && !location.href.startsWith(baseUrl)) {
        url += `?${buildQueryParams()}`;
    }

    return url;
};

const goTo = (url: string, newTab = false): void => {
    if (newTab) {
        window.open(url, '_blank');
        return;
    }

    if (window.location.href === url) {
        return;
    }

    window.location.href = url;
};

export const nativeLink = (path: string): string => {
    const base = process.env.VUE_APP_BASE_URL;
    if (!base) {
        return '';
    }

    const cleanedPath = path.replace(/^#?\/?/, '');
    const fullUrl = `${base}#${cleanedPath}`;

    if (window.location.href.startsWith(base)) {
        return fullUrl;
    }

    return `${base}?${buildQueryParams()}#${cleanedPath}`;
};

export const goToNativeLink = (path: string, newTab = false): void => {
    goTo(nativeLink(path), newTab);
};

export const ordersLink = (path: string): string => buildLink(process.env.VUE_APP_SWITCHER_ORDERS_URL, path);

export const goToOrdersLink = (path: string, newTab: boolean = false): void => {
    goTo(ordersLink(path), newTab);
};

export const mainLink = (path: string): string => buildLink(process.env.VUE_APP_SWITCHER_NEW_MAIN_URL, path);

export const goToMainLink = (path: string, newTab: boolean = false): void => {
    goTo(mainLink(path), newTab);
};

export const adminLink = (path: string): string => buildLink(process.env.VUE_APP_SWITCHER_ADMIN_URL, path);

export const goToAdminLink = (path: string, newTab: boolean = false): void => {
    goTo(adminLink(path), newTab);
};

export const goToCurrent = (path: string): void => {
    if (!process.env.VUE_APP_BASE_URL) {
        return;
    }

    const cleanPath = path.replace(/^#?\/?/, '');
    window.location.href = `${process.env.VUE_APP_BASE_URL}#/${cleanPath}`;
};
